var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 16C3.33325 10.0293 3.33325 7.04268 5.18792 5.18801C7.04259 3.33334 10.0279 3.33334 15.9999 3.33334C21.9706 3.33334 24.9573 3.33334 26.8119 5.18801C28.6666 7.04268 28.6666 10.028 28.6666 16C28.6666 21.9707 28.6666 24.9573 26.8119 26.812C24.9573 28.6667 21.9719 28.6667 15.9999 28.6667C10.0293 28.6667 7.04259 28.6667 5.18792 26.812C3.33325 24.9573 3.33325 21.972 3.33325 16Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.344 8.66669H23.3307M22 16C22 17.5913 21.3679 19.1174 20.2426 20.2427C19.1174 21.3679 17.5913 22 16 22C14.4087 22 12.8826 21.3679 11.7574 20.2427C10.6321 19.1174 10 17.5913 10 16C10 14.4087 10.6321 12.8826 11.7574 11.7574C12.8826 10.6322 14.4087 10 16 10C17.5913 10 19.1174 10.6322 20.2426 11.7574C21.3679 12.8826 22 14.4087 22 16Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7467a6197967bffca8b0d1593d678ae0.svg";
export { ForwardRef as ReactComponent };